"use client"

import { QuestionCircle as CircleHelpIcon } from "@papier/ui/components/icons"

import { Button } from "@papier/ui/components/ui/button"
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger
} from "@papier/ui/components/ui/dialog"
import { cn } from "@papier/ui/lib/utils"

export interface TwoFactorScanHelpDialogProps {
    className?: string
}

export function TwoFactorScanHelpDialog({
    className
}: TwoFactorScanHelpDialogProps) {
    return (
        <Dialog>
            <DialogTrigger asChild>
                <Button
                    type="button"
                    variant="ghost"
                    size="sm"
                    className={cn(
                        "text-primary h-auto gap-1.5 p-0 text-sm hover:bg-transparent hover:underline",
                        className
                    )}
                >
                    <CircleHelpIcon className="size-4" />
                    Probleme la scanarea codului?
                </Button>
            </DialogTrigger>

            <DialogContent className="max-h-[85vh] overflow-y-auto sm:max-w-2xl">
                <DialogHeader>
                    <DialogTitle>
                        Dacă Microsoft Authenticator nu scanează codul
                    </DialogTitle>

                    <DialogDescription>
                        Urmează acești pași pentru configurarea manuală.
                    </DialogDescription>
                </DialogHeader>

                <ol className="grid list-decimal gap-3 pl-5 text-sm">
                    <li>
                        Deschide aplicația Microsoft Authenticator, apasă pe{" "}
                        <span className="font-medium">+</span> (dreapta sus) și
                        alege <span className="font-medium">Other</span>{" "}
                        (Altele).
                    </li>
                    <li>
                        Selectează{" "}
                        <span className="font-medium">Set up manually</span>{" "}
                        (Configurare manuală).
                    </li>
                    <li>
                        Introdu un nume pentru cont și codul afișat pe ecran,
                        apoi salvează.
                    </li>
                </ol>

                <p className="text-muted-foreground text-sm">
                    <span className="text-foreground font-medium">
                        Alternativă:
                    </span>{" "}
                    Descarcă aplicația Google Authenticator și încearcă scanarea
                    cu aceasta.
                </p>
            </DialogContent>
        </Dialog>
    )
}
